import { QueryHookOptions, useQuery } from '@apollo/client';
import query from '../../queries/configurationSummary';
import { VehicleModel } from './useVehicleModels';
import { VehicleOption } from './useVehicleOptions';

export interface ConfigurationSummary {
  vehicleModel: VehicleModel;
  vehicleOptions: VehicleOption[];
  basePrice: number;
  subtotal: number;
  preorderDepositAmount: number;
  dueAmount: number;
  preorderPaidAmount: number;
  preorderBalance: number;
}

export interface Params {
  vehicleModelId?: number;
  vehicleOptionIds?: number[];
  orderNum?: string;
}

interface UseConfigurationSummaryRequest {
  configurationInput: Params;
}

interface UseConfigurationSummaryResponse {
  configurationSummary: ConfigurationSummary;
}

export default function useConfigurationSummary(params: Params, options: QueryHookOptions<UseConfigurationSummaryResponse, UseConfigurationSummaryRequest> = {}) {
  const { data, ...rest } = useQuery<UseConfigurationSummaryResponse, UseConfigurationSummaryRequest>(query, {
    ...options,
    variables: {
      configurationInput: params
    }
  });

  const configurationSummary = data?.configurationSummary;

  return {
    configurationSummary,
    ...rest
  };
}
